import * as React from 'react';

import styles from './styles.module.scss';

const NoRowsFound: React.FC = () => {
	return (
		<div className={styles.noRowsFound}>
			<span className={`icon-info ${styles.iconInfo}`} />
			No rows found
		</div>
	);
};

export default React.memo(NoRowsFound);
